export const generateCreativeName = (activePreviews, creativeName, index) =>
    creativeName && activePreviews.length > 1 ? `${creativeName} ${index + 1}` : creativeName;
